export default {
  name: 'marking--treeMrkLoadCustom',
  apiService: 'shoes',
  apiPath: '/admin/mrk/func/load/custom',
  urlParamName: 'marking--treeMrkLoadCustom',
};